<template>
  <div class="master-maintenance">
    <v-container>
      <v-card flat>
        <v-card-title>
          商品マスタメンテナンス
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-select
                label="編集対象"
                v-model="editingId"
                :items="itemList"
                item-value="id"
                item-text="text"
                @change="handleSelectChange"
              ></v-select>
            </v-col>
            <!-- <v-col>
              <v-btn outlined color="primary" @click="handleAddNew">
                新規商品作成
              </v-btn>
            </v-col> -->
          </v-row>

          <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <template v-else>
            <v-text-field
              label="商品名"
              v-model="editingItem.name"
            ></v-text-field>
            <v-text-field
              label="販売名称"
              v-model="editingItem.display_name"
            ></v-text-field>
            <v-textarea
              label="商品説明"
              v-model="editingItem.content"
              auto-grow
            ></v-textarea>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  label="ソート順"
                  v-model="editingItem.order"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  label="在庫計上"
                  v-model="editingItem.inventory_merchandise_id"
                  :items="inventoryItemList"
                  item-value="id"
                  item-text="text"
                ></v-select>
              </v-col>
            </v-row>
            <v-data-table :headers="headers" :items="editingItem.types">
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        outlined
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        商品種別追加
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="6">
                              <v-select
                                v-model="editedTypeItem.price_type_id"
                                label="種別"
                                :items="priceTypeIds"
                                item-value="id"
                                item-text="text"
                                @change="handlePriceTypeChange"
                              ></v-select>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                v-model="editedTypeItem.size"
                                label="サイズ"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="editedTypeItem.name"
                                label="名称"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                v-model="editedTypeItem.price"
                                label="価格"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                v-model="editedTypeItem.weight"
                                label="重量"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">
                          キャンセル
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="save">
                          OK
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5">
                        この行を削除してもよろしいですか?
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItemConfirm"
                        >
                          OK
                        </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </template>
              <!-- <template v-slot:no-data>
              <v-btn text color="primary" @click="initialize">
                Reset
              </v-btn>
            </template> -->
            </v-data-table>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" :loading="updating" @click="handleUpdate">
            保存する
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Get as axiosGet, Post as axiosPost } from '../assets/request-api.js';

export default {
  components: {},
  data: () => ({
    loading: false,
    merchandiseList: [],
    priceTypeList: [],
    editingId: 0,
    editingItem: {
      id: 0,
      name: '',
      display_name: '',
      content: '',
      order: 0,
      inventory_merchandise_id: 0,
      types: [],
    },
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: '種別', value: 'price_type_text' },
      { text: 'サイズ', value: 'size' },
      { text: '名称', value: 'name' },
      { text: '価格（税込）', value: 'price' },
      { text: '重量（在庫用）', value: 'weight' },
      { text: '', value: 'actions', sortable: false },
    ],
    editedTypeIndex: -1,
    editedTypeItem: {
      id: 0,
      merchandise_id: 0,
      name: '',
      price: 0,
      price_type_id: 0,
      price_type_text: '',
      size: 0,
      weight: 0,
    },
    defaultTypeItem: {
      id: 0,
      merchandise_id: 0,
      name: '',
      price: 0,
      price_type_id: 0,
      price_type_text: '',
      size: 0,
      weight: 0,
    },
    updating: false,
  }),
  computed: {
    ...mapGetters({
      accessToken: 'auth/accessToken',
    }),
    itemList() {
      return [
        { id: 0, text: '選択してください' },
        ...this.merchandiseList.map(item => ({
          id: item.id,
          text: item.name,
        })),
      ];
    },
    inventoryItemList() {
      return [
        { id: 0, text: 'この科目で集計' },
        ...this.merchandiseList.map(item => ({
          id: item.id,
          text: item.name,
        })),
      ];
    },
    config() {
      return {
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
        },
      };
    },
    priceTypeIds() {
      return [
        { id: 0, text: '一般' },
        ...this.priceTypeList.map(el => ({ id: el.id, text: el.name })),
      ];
    },
  },
  methods: {
    handleAddNew() {
      this.editingId = 0;
      this.editingItem = {
        id: 0,
        name: '',
        display_name: '',
        content: '',
        order: 0,
        inventory_merchandise_id: 0,
        types: [],
      };
    },
    async handleSelectChange() {
      this.loading = true;
      const url = '/mainte/merchandise/' + this.editingId;
      const result = await axiosGet(url, this.config);

      if (RegExp(/^2[0-9]{2}$/u).test(result.statusCode)) {
        this.editingItem = {
          ...result.response,
          inventory_merchandise_id:
            result.response.id == result.response.inventory_merchandise_id
              ? 0
              : result.response.inventory_merchandise_id,
        };
      }
      this.loading = false;
    },
    editItem(item) {
      this.editedTypeIndex = this.editingItem.types.indexOf(item);
      this.editedTypeItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedTypeIndex = this.editingItem.types.indexOf(item);
      this.editedTypeItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.editingItem.types.splice(this.editedTypeIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedTypeItem = Object.assign({}, this.defaultTypeItem);
        this.editedTypeIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedTypeItem = Object.assign({}, this.defaultTypeItem);
        this.editedTypeIndex = -1;
      });
    },

    save() {
      if (this.editedTypeItem.price_type_text == '') {
        this.editedTypeItem.price_type_text = '一般';
      }
      if (this.editedTypeIndex > -1) {
        Object.assign(
          this.editingItem.types[this.editedTypeIndex],
          this.editedTypeItem
        );
      } else {
        this.editingItem.types.push(this.editedTypeItem);
      }
      this.close();
    },
    handlePriceTypeChange() {
      const text = this.priceTypeIds.find(
        el => el.id == this.editedTypeItem.price_type_id
      ).text;
      this.editedTypeItem.price_type_text = text;
    },
    handleUpdate() {
      this.updating = true;
      const url = '/mainte/merchandise/' + this.editingId;
      axiosPost(url, this.editingItem, this.config)
        .then(result => {
          if (RegExp(/^2[0-9]{2}$/u).test(result.statusCode)) {
            alert('更新しました！');
            axiosGet('/merchandise', this.config).then(result => {
              if (RegExp(/^2[0-9]{2}$/u).test(result.statusCode)) {
                this.merchandiseList = result.response;
              }
            });
          }
        })
        .finally(() => {
          this.updating = false;
        });
    },
  },
  created() {
    axiosGet('/merchandise', this.config).then(result => {
      if (RegExp(/^2[0-9]{2}$/u).test(result.statusCode)) {
        this.merchandiseList = result.response;
      }
    });
    axiosGet('pricetypes', this.config).then(result => {
      if (RegExp(/^2[0-9]{2}$/u).test(result.statusCode)) {
        this.priceTypeList = result.response;
      }
    });
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style></style>
